import React from 'react';
import './InfoCard.scss';

export interface InfoCardProps {
  title: string;
  subtitle?: string;
  iconSrc?: string;
  iconAlt?: string;
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  subtitle,
  iconSrc,
  iconAlt = '',
  children,
  className = '',
  actions,
}) => {
  return (
    <div className={`info-card ${className}`}>
      <div className="info-card__header">
        <div className="info-card__titles">
          {iconSrc && (
            <img src={iconSrc} alt={iconAlt} className="info-card__icon" />
          )}
          <h2 className="info-card__title">{title}</h2>
          {subtitle && <p className="info-card__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="info-card__actions">{actions}</div>}
      </div>
      <div className="info-card__content">{children}</div>
    </div>
  );
};

